import { replaceUrlParam } from "@/utils"
/**
 * 详情页插件
 */
class DetailPage {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
    this.typeId = this.context.$store.state.states.getDataPageIds.typeId
    this.appId = this.context.$store.state.states.getDataPageIds.appId
    this.subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    this.showBreadCrumbs = this.subPage.detailPageSetting.showBreadCrumbs
    this.homePageId = this.context.$store.state.states.getDataPageIds.homePageId
    this.listPageId = this.context.$store.state.states.getDataPageIds.listPageId
    this.name = this.subPage.detailPageSetting.name
    this.showPrevNext = this.subPage.detailPageSetting.showPrevNext
    this.engineId = this.context.$store.state.states.getDataPageIds.engineInstanceId
    this.dataId = this.context.$store.state.states.getDataPageIds.dataId
    this.isPhoneFullScreen = this.context.$store.state[this.request_prefix].page.isPhoneFullScreen // 翻页模版标识
    this.appType = this.context.$store.state[this.request_prefix].page.children[0]?.children?.find(
      item => item.options.appId === this.appId
    )?.shape //查找是哪个应用的子页面
  }
  async init() {
    sessionStorage.removeItem("hasBreadCrumbs")
    sessionStorage.removeItem("hasPrevNext")
    // 处理翻页模版转常页
    if (this.isPhoneFullScreen) {
      this.context.$store.dispatch(this.request_prefix + "/changePhoneFullScreen", false)
      this.context.$store.dispatch(this.request_prefix + "/changePageLayoutType", "layOut")
      this.context.$store.dispatch(this.request_prefix + "/changeOnlyH5Template", true)
    }
    // 判断是否显示面包屑
    const breadCrumbsData = await this.getBreadCrumbsData()

    this.context.$eventBus.$on("detailPage-component-init", msg => {
      switch (msg.type) {
        case "cxNoteEditor":
          this.initIntroductionData("", msg.type + "_" + msg.businessId) // 编辑页不需要获取数据
          break
        case "cxBreadCrumbs":
          console.log("cxBreadCrumbscxBreadCrumbs")
          this.initBreadCrumbsData(breadCrumbsData, msg.type + "_" + msg.businessId)
          break
        case "cxNavMenuVertical":
          this.initVerticalNavMenuData(msg.type + "_" + msg.businessId)
          break
      }
    })
    // 判断是否显示面包屑
    if (breadCrumbsData.data.code === 1) {
      // 上一篇下一篇需要这个值
      this.restDataUrl = breadCrumbsData.data.data.restDataUrl
    }
    // const rectAttr = this.findBreadCrumbs()
    // if (rectAttr) {
    //   sessionStorage.setItem("hasBreadCrumbs", "1")
    // }
    // if (this.showBreadCrumbs) {
    //   if (breadCrumbsData.data.code === 1) {
    //     this.initBreadCrumbsData(breadCrumbsData)
    //   }
    // } else {
    //   if (rectAttr) {
    //     let ids = {
    //       container_id: 0,
    //       rect_id: rectAttr.rect_id
    //     }
    //     this.context.$changeOptionsEV(0, "opacity", false, null, ids, true)
    //   }
    // }
    const prev_rect_id = this.findPrevBtn()
    const next_rect_id = this.findNextBtn()
    if (prev_rect_id || next_rect_id) {
      sessionStorage.setItem("hasPrevNext", "1")
    }
    // 判断是否显示上一篇下一篇
    if (this.showPrevNext) {
      this.initPrevNextData()
    } else {
      if (prev_rect_id) {
        const prev_ids = {
          container_id: 0,
          rect_id: prev_rect_id.rect_id
        }
        this.context.$changeOptionsEV(0, "opacity", false, null, prev_ids, true)
      }
      if (next_rect_id) {
        const next_ids = {
          container_id: 0,
          rect_id: next_rect_id.rect_id
        }
        this.context.$changeOptionsEV(0, "opacity", false, null, next_ids, true)
      }
    }
  }
  async getBreadCrumbsData() {
    return this.context.$API.queryCrumbData({
      typeId: this.typeId,
      e: this.engineId
    })
  }
  initBreadCrumbsData(breadCrumbsData, key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initDetailPageBreadCrumbsData(this.showBreadCrumbs, breadCrumbsData, this.homePageId, this.listPageId)
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxBreadCrumbs") !== -1) {
          this.context.$subPageEvent.contexts[key].initDetailPageBreadCrumbsData(this.showBreadCrumbs, breadCrumbsData, this.homePageId, this.listPageId)
        }
      })
    }
  }
  initVerticalNavMenuData(key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initDetailPageNavMenuData(this)
    }
  }
  // 请求完数据后更新面包屑组件
  // initBreadCrumbsData(breadCrumbsData) {
  //   const homePageUrl = replaceUrlParam(window.location.href, "p", this.homePageId)
  //   const listPageUrl = replaceUrlParam(window.location.href, "p", this.listPageId)
  //   let homePageName = ""
  //   let subPageName = window.localStorage.getItem("appName")
  //   if (breadCrumbsData) {
  //     homePageName = breadCrumbsData.data?.data?.pageName //修改了接口，当前页面名称返回到获取面包屑接口中
  //     // 判断是初始化还是点击多级导航后的数据联动
  //     const sourceData = [
  //       {
  //         label: homePageName ? homePageName : "首页",
  //         path: homePageUrl
  //       },
  //       {
  //         label: subPageName ? subPageName : "图文",
  //         path: listPageUrl
  //       }
  //     ]
  //     const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
  //       label: item.name,
  //       value: item.id,
  //       path: listPageUrl
  //     }))
  //     sourceData.push(...crumbsData)
  //     // 导航菜单的详情页面包屑不显示名称
  //     // if (this.appType === "cxNavMenu") {
  //     //   // 删掉第二个元素
  //     //   sourceData.splice(1, 1)
  //     // }
  //     const rect_id = this.findBreadCrumbs()?.rect_id
  //     const ids = {
  //       container_id: 0,
  //       rect_id: rect_id
  //     }
  //     // 获取当前标题
  //     const detailData = JSON.parse(window.localStorage.getItem("detailData"))
  //     // 数据源为表单时 不知道哪一项为标题
  //     let titleInKey = detailData
  //       ? Object.keys(detailData[0]).find(key => {
  //           if (detailData[0][key]?.key?.includes("名称") || detailData[0][key]?.key?.includes("标题")) {
  //             return key
  //           }
  //         })
  //       : -1
  //     titleInKey = titleInKey === -1 ? 1 : titleInKey
  //     const title = detailData[0][titleInKey]?.value
  //     sourceData.push({ label: title })
  //     this.context.$changeOptionsEV(sourceData, "sourceData", false, null, ids, true)
  //   }
  // }
  // 找到面包屑组件（container_id, rect_id）
  findBreadCrumbs() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.shape === "cxBreadCrumbs"
    })[0]
  }
  GetRequest() {
    var url = location.href //获取url中"?"符后的字串
    var theRequest = new Object()
    if (url.indexOf("?") != -1) {
      var str = url.split("?")[1]
      var strs = str.split("&")
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
      }
    }
    return theRequest
  }
  findPrevBtn() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options.type === "prev"
    })[0]
  }
  findNextBtn() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options.type === "next"
    })[0]
  }
  initPrevNextData() {
    const detailData = JSON.parse(window.localStorage.getItem("detailData"))
    if (!detailData) return
    const { formId } = this.context.$store.state.states.getDataPageIds
    if (formId) {
      this.initPrevNextDataForm()
      return
    }
    const prev_rect_id = this.findPrevBtn()?.rect_id
    const next_rect_id = this.findNextBtn()?.rect_id
    const prev_ids = {
      container_id: 0,
      rect_id: prev_rect_id
    }
    const next_ids = {
      container_id: 0,
      rect_id: next_rect_id
    }
    this.context.$changeOptionsEV("上一篇", "content", false, null, prev_ids, true)
    this.context.$changeOptionsEV("下一篇", "content", false, null, next_ids, true)
    const { nextData } = detailData[0]
    if (nextData && next_rect_id !== null && next_rect_id !== undefined) {
      const { name } = nextData
      this.context.$changeOptionsEV(`下一篇：${name}`, "content", false, null, next_ids, true)
    }
    // 数据源为表单时 不知道哪一项为简介
    let introductionInKey = Object.keys(detailData[0]).find(key => {
      if (detailData[0][key]?.key?.includes("简介")) {
        return key
      }
    })
    if(typeof introductionInKey === 'undefined'){
      return
    }
    const introduction = detailData[0][introductionInKey].value
    console.log('introduction :>>',introduction);
    this.initIntroductionData(introduction, true)
  }
  // 表单数据源接口不能返回上下一篇的数据，还得从列表页查询
  async initPrevNextDataForm() {
    const prev_rect_id = this.findPrevBtn()?.rect_id
    const next_rect_id = this.findNextBtn()?.rect_id
    const prev_ids = {
      container_id: 0,
      rect_id: prev_rect_id
    }
    const next_ids = {
      container_id: 0,
      rect_id: next_rect_id
    }
    this.context.$changeOptionsEV("上一篇", "content", false, null, prev_ids, true)
    this.context.$changeOptionsEV("下一篇", "content", false, null, next_ids, true)
    const listData = await this.getListData()
    if (listData.data.code === 1) {
      const total = listData.data.data.datas.totalRecords
      const data = listData.data.data.datas.datas
      if (!data || data.length === 0) return
      // 数据源为表单时 不知道哪一项为标题
      let titleInKey = Object.keys(data[0]).find(key => {
        if (data[0][key]?.key?.includes("名称") || data[0][key]?.key?.includes("标题")) {
          return key
        }
      })
      titleInKey = titleInKey === undefined ? 1 : titleInKey
      let curIndex = data.findIndex(item => item.publicId === this.dataId)
      // 数据源为表单时 有些没有publicId
      if (curIndex == -1) {
        curIndex = data.findIndex(item => item.id === this.dataId)
      }
      if (curIndex == -1) return
      if (curIndex < total - 1) {
        const nextTitle = data[curIndex + 1][titleInKey].value
        this.context.$changeOptionsEV(`下一篇：${nextTitle}`, "content", false, null, next_ids, true)
      }
      // 数据源为表单时 不知道哪一项为简介
      let introductionInKey = Object.keys(data[0]).find(key => {
        if (data[0][key]?.key?.includes("简介")) {
          return key
        }
      })
      if(typeof introductionInKey === 'undefined'){
        return
      }
      const introduction = data[curIndex + 1][introductionInKey].value
      this.initIntroductionData(introduction, true)
    }
  }
  async getListData() {
    let restDataUrl = this.restDataUrl?.replace("engineInstanceId", "e").replace("typeId", "t")
    let url = restDataUrl ? replaceUrlParam(restDataUrl, "t", this.typeId ? this.typeId : "") : ""
    return this.context.asyncTask.add(this.context.instance.get(`${url}&p2=100&p=`))
  }
  handleDetailPageSetting(type) {
    const subPage = JSON.parse(
      window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.context.request_prefix)
    )
    const value = subPage.detailPageSetting[type]
    // 更新变量
    this[type] = value
    if (type === "showBreadCrumbs") {
      const rectAttr = this.findBreadCrumbs()
      if (!rectAttr) return
      this.initBreadCrumbsData()
      // let ids = {
      //   container_id: 0,
      //   rect_id: rectAttr.rect_id
      // }
      // this.context.$changeOptionsEV(value ? 100 : 0, "opacity", false, null, ids, true)
    }
    if (type === "showPrevNext") {
      const prev_rect_id = this.findPrevBtn()
      const next_rect_id = this.findNextBtn()
      if (prev_rect_id) {
        const prev_ids = {
          container_id: 0,
          rect_id: prev_rect_id.rect_id
        }
        this.context.$changeOptionsEV(value ? 100 : 0, "opacity", false, null, prev_ids, true)
      }
      if (next_rect_id) {
        const next_ids = {
          container_id: 0,
          rect_id: next_rect_id.rect_id
        }
        this.context.$changeOptionsEV(value ? 100 : 0, "opacity", false, null, next_ids, true)
      }
    }
  }

  // 更新简介区域数据
  initIntroductionData(introduction, isShow, key) {
    if (this.context.$subPageEvent.contexts[key]) {
      this.context.$subPageEvent.contexts[key].initListPageIntroductionData(introduction, isShow)
    } else {
      Object.keys(this.context.$subPageEvent.contexts).forEach(key => {
        if (key.indexOf("cxNoteEditor") !== -1) {
          this.context.$subPageEvent.contexts[key].initListPageIntroductionData(introduction, isShow)
        }
      })
    }
  }
}
export default {
  methods: {
    detailPagePlugin() {
      const detailPage = new DetailPage(this)
      this.detailPage = detailPage
      detailPage.init()
    },
    handleDetailPageSetting(type) {
      this.detailPage?.handleDetailPageSetting(type)
    }
  }
}
